import { Component } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MealPlanServiceV2 } from '../meal-plan-v2.service';
import { MealPlanService } from '../../meal-plan/meal-plan.service';
import { ActivatedRoute } from '@angular/router';
import { NgFor } from '@angular/common';
import { NgIf, formatDate } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { Router } from "@angular/router";
import { ToastService } from '../../services/toast.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDateRangeInput } from '@angular/material/datepicker';
import { MatLabel } from '@angular/material/form-field';
import { MatHint } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MealMemberBasicDetailsComponent } from '../../meal-plan/meal-member-basic-details/meal-member-basic-details.component';
import { SharedServiceService } from '../../services/shared-service.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
declare var $: any;

@Component({
  selector: 'app-all-meals',
  standalone: true,
  imports: [MealMemberBasicDetailsComponent, MatProgressSpinnerModule, NgxMaterialTimepickerModule, MatDatepickerModule, MatHint, MatFormFieldModule, MatLabel, MatInputModule, MatNativeDateModule, MatDateRangeInput, MatListModule, NgFor, NgIf, NgClass, FormsModule],
  templateUrl: './all-meals.component.html',
  styleUrl: './all-meals.component.css'
})

export class AllMealsComponentV2 {
  memberId: any;
  meals: any = [];
  isType: any = 1;
  mealTitle = 'Draft Meals';
  existingMealPlan: any;
  exisitngMealPlanName: any;
  newMealPlan: any;
  memMealDate: string = '';
  currentDate: any = '';
  minDate: any;
  maxDate: any;
  pendingAssignMeal: any = null;
  pendingUnassignMeal: any = null;
  toDelDraftPlanId: any = null;
  toDelDraftPlanName: string = '';
  nonSevenDayPlanDays: number = 0; // used in "cannot extend" modal message
  nonSevenDayPlanMaxDate: string = ''; // max date user can extend to (for <7 day plans)
  userId: any;
  isCreatingTemplate = false;
  showCreateTemplateSuccessModal = false;
  createTemplateSuccessMealPlanName = '';
  cannotCreateTemplateMealName: string = '';
  cannotCreateTemplateMealDayCount: number = 0;
  showMealPlanUnavailableModal = false;
  mealPlanUnavailableIsAppCreated = false;
  showOnlyOnePreviewModal = false;

  // Plan Inputs modal — shows the question/answer pairs Renne used to auto-generate this meal plan
  planInputsModalOpen = false;
  planInputsLoading = false;
  planInputsError: string = '';
  planInputsMealName: string = '';
  planInputsQuestions: any[] = [];
  // Questions whose answer pill should reveal a free-text note below it, keyed by questionId.
  private readonly freeTextTriggerLabels: { [questionId: string]: string[] } = {
    '17': ['Add Note'],
    '4': ['Something else - let me describe']
  };

  constructor(private toast: ToastService, private mealService: MealPlanService, private mealService2: MealPlanServiceV2,
    private route: ActivatedRoute, private router: Router, private sharedService: SharedServiceService) {
  }

  ngOnInit(): void {
    this.memberId = this.route.snapshot.queryParamMap.get('memberId');
    this.sharedService.checkLogin().subscribe({
      next: (isLoggedIn: boolean) => {
        const user = this.sharedService.getLoggedInUser();
        this.userId = user?.id;
      },
      error: () => {}
    });
    this.route.queryParams.subscribe(params => {
      if (params['isType']) {
        this.isType = Number(params['isType']);
        if (this.isType == 4) {
          this.getDraftMeals();
        }
      }
    });
  }

  getDraftMeals(): void {
    this.isType = 4;
    this.mealTitle = 'Draft Meal Plan';
    this.getAllMeals('draft');

  }
  getUpComingMeals(): void {
    this.isType = 3;
    this.mealTitle = 'Upcoming Meal Plan';
    this.getAllMeals('upcoming');

  }
  getOngoingMeals(): void {
    this.isType = 1;
    this.mealTitle = 'Ongoing Meal Plan';
    this.getAllMeals('ongoing');

  }
  getCompletedMeals(): void {
    this.isType = 2;
    this.mealTitle = 'Completed Meal Plan';
    this.getAllMeals('completed');
  }

  getAllMeals(type: string) {
    this.meals = [];
    this.mealService2.getAllMeals(this.memberId, formatDate(Date.now(), 'yyyy-MM-dd', 'en-US'), type)
      .subscribe((response: any) => {
        const list = Array.isArray(response) ? response : [];
        this.meals = list.map((meal: any) => {
          // For draft tab we allow editing of date range and meal plan name using separate edit fields
          const from = meal.fromDate ? String(meal.fromDate).split('T')[0] : '';
          const to = meal.toDate ? String(meal.toDate).split('T')[0] : '';
          return {
            ...meal,
            // normalize to a real boolean since API may send true/false or "true"/"false"
            isAppCeatedPlan: meal.isAppCeatedPlan === true || meal.isAppCeatedPlan === 'true',
            // store original dates coming from API
            _originalFromDate: from,
            _originalToDate: to,
            // editable copies bound to the date inputs
            _fromDateEdit: from,
            _toDateEdit: to,
            // editable meal plan name (draft tab only); send to backend only when changed
            _mealPlanNameEdit: meal.mealPlanName || ''
          };
        });
      });
  }
  formatDate(d: any) {
    return formatDate(d, 'MMMM d, y', 'en-US');
  }

  // Meal plans with no mealPlanId were never successfully created; block any action on them
  // and explain why instead of hitting the API.
  private isMealPlanUsable(meal: any): boolean {
    if (!meal || !meal.mealPlanId) {
      this.mealPlanUnavailableIsAppCreated = !!(meal && meal.isAppCeatedPlan);
      this.showMealPlanUnavailableModal = true;
      return false;
    }
    return true;
  }

  closeMealPlanUnavailableModal(): void {
    this.showMealPlanUnavailableModal = false;
  }

  closeOnlyOnePreviewModal(): void {
    this.showOnlyOnePreviewModal = false;
  }
  openDeleteDraftConfirm(meal: any) {
    this.toDelDraftPlanId = meal.id;
    this.toDelDraftPlanName = meal.mealPlanName || 'this meal plan';
    $('#confirmDeleteDraft').modal('show');
  }

  closeDeleteDraftConfirm() {
    $('#confirmDeleteDraft').modal('hide');
    this.toDelDraftPlanId = null;
    this.toDelDraftPlanName = '';
  }

  confirmDeleteDraft() {
    const id = this.toDelDraftPlanId;
    this.closeDeleteDraftConfirm();
    if (id != null) {
      this.deleteMealPlan(id);
    }
  }

  deleteMealPlan(id: any) {
    this.mealService2.deleteMealPlan(id).subscribe(response => {
      this.toast.successMessage('Meal Plan Deleted Successfully');
      this.getAllMeals('draft');
    });
  }

  private setMealPlanHideStatus(meal: any, isHide: boolean) {
    return this.mealService2.updateMealPlanHideStatus({
      id: meal.id,
      memberId: this.memberId,
      mealPlanId: meal.mealPlanId,
      isHide
    });
  }

  toggleMealPlanHide(meal: any): void {
    // Visibility is a flag on the meal plan record itself, so this toggle is allowed
    // even when the underlying plan is otherwise unusable (missing mealPlanId).
    const newIsHide = meal.isHide !== true;
    // Only one meal plan can be shown for preview in the app at a time.
    if (newIsHide && this.meals.some((m: any) => m !== meal && m.isHide === true)) {
      this.showOnlyOnePreviewModal = true;
      return;
    }
    this.setMealPlanHideStatus(meal, newIsHide).subscribe((response: any) => {
      if (response == 1) {
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      } else {
        meal.isHide = newIsHide;
        this.toast.successMessage(newIsHide ? 'Meal Plan Hidden Successfully' : 'Meal Plan Visible Successfully');
      }
    });
  }
  formatTime(d: any) {
    return new Date(d).toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  }

  // Update draft meal plan start/end dates and optionally name (Draft tab only)
  updateDraftMealDates(meal: any) {
    if (!this.isMealPlanUsable(meal)) {
      return;
    }
    const from = meal._fromDateEdit;
    const to = meal._toDateEdit;
    const editedName = (meal._mealPlanNameEdit || '').trim();
    const originalName = (meal.mealPlanName || '').trim();

    const originalFrom = meal.fromDate ? String(meal.fromDate).split('T')[0] : '';
    const originalTo = meal.toDate ? String(meal.toDate).split('T')[0] : '';

    const hasFromChanged = from !== originalFrom;
    const hasToChanged = to !== originalTo;
    const hasNameChanged = editedName !== originalName;

    // If nothing changed, avoid unnecessary API call
    if (!hasFromChanged && !hasToChanged && !hasNameChanged) {
      this.toast.errorMessage('No changes to update.');
      return;
    }

    // Effective dates used for validation (mix of original & edited)
    const effFrom = hasFromChanged ? from : originalFrom;
    const effTo = hasToChanged ? to : originalTo;

    if (!effFrom || !effTo) {
      this.toast.errorMessage('Please select valid start and end dates.');
      return;
    }

    const fromDate = new Date(effFrom);
    const toDate = new Date(effTo);

    if (fromDate > toDate) {
      this.toast.errorMessage('End date must be greater than or equal to start date.');
      return;
    }

    // Allow reducing end date. When extending and plan has <7 days, allow only up to startDate + (mealDayCount - 1)
    const newEndDate = new Date(effTo);
    const originalEndDate = new Date(originalTo);
    const isExtending = newEndDate > originalEndDate;

    let displayDayCount: number;
    if (meal.mealDayCount != null) {
      displayDayCount = Number(meal.mealDayCount);
    } else {
      const oneDayMs = 1000 * 60 * 60 * 24;
      const origFromDate = new Date(originalFrom);
      const origToDate = new Date(originalTo);
      displayDayCount = Math.round((origToDate.getTime() - origFromDate.getTime()) / oneDayMs) + 1;
    }
    const isFullSevenDayPlan = displayDayCount >= 7;

    if (!isFullSevenDayPlan && isExtending) {
      // Max allowed end date = start date + (mealDayCount - 1) days
      const startDate = new Date(effFrom);
      const maxAllowedEndDate = new Date(startDate);
      maxAllowedEndDate.setDate(maxAllowedEndDate.getDate() + displayDayCount - 1);

      if (newEndDate <= maxAllowedEndDate) {
        // Within allowed range: allow update
      } else {
        this.nonSevenDayPlanDays = displayDayCount;
        this.nonSevenDayPlanMaxDate = this.formatDate(maxAllowedEndDate);
        $('#nonSevenDayPlanWarning').modal('show');
        return;
      }
    }

    const payload: any = {
      id: meal.id,
      memberId: this.memberId
    };

    // Backend expects plain date strings in yyyy-MM-dd format
    if (hasFromChanged) {
      payload.fromDate = from;
    }
    if (hasToChanged) {
      payload.toDate = to;
    }
    // Send meal plan name only when user edited it
    if (hasNameChanged && editedName) {
      payload.mealPlanName = editedName;
    }

    this.mealService2.updateDraftMealPlanDates(payload).subscribe((response: any) => {
      if (response === 1) {
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      } else {
        this.toast.successMessage('Meal Plan dates updated successfully');
        // Refresh drafts list so UI reflects latest dates
        this.getDraftMeals();
      }
    });
  }

  onNonSevenDayPlanWarningOk(): void {
    $('#nonSevenDayPlanWarning').modal('hide');
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { memberId: this.memberId, isType: 4 },
      queryParamsHandling: 'merge'
    });
    this.getDraftMeals();
  }

  // wrapper for Assign button: directly show assign confirmation
  assignOrWarn(meal: any) {
    if (!this.isMealPlanUsable(meal)) {
      return;
    }
    this.pendingAssignMeal = meal;
    $('#confirmAssignToMember').modal('show');
  }

  confirmAssignToMember() {
    $('#confirmAssignToMember').modal('hide');
    if (this.pendingAssignMeal) {
      this.assignMealPlan(this.pendingAssignMeal);
      this.pendingAssignMeal = null;
    }
  }

  closeConfirmAssignToMember() {
    $('#confirmAssignToMember').modal('hide');
    this.pendingAssignMeal = null;
  }

  openUnassignConfirm(meal: any) {
    this.pendingUnassignMeal = meal;
    $('#confirmUnassign').modal('show');
  }

  confirmUnassign() {
    if (this.pendingUnassignMeal != null) {
      const meal = this.pendingUnassignMeal;
      this.pendingUnassignMeal = null;
      $('#confirmUnassign').modal('hide');
      this.doUnassignMealPlan(meal);
    }
  }

  closeConfirmUnassign() {
    $('#confirmUnassign').modal('hide');
    this.pendingUnassignMeal = null;
  }

  private doUnassignMealPlan(meal: any) {
    const payload = {
      currentObjectId: meal.id,
      date: formatDate(new Date(), 'yyyy-MM-dd', 'en-US'),
      reqType: 'toDraft'
    };
    this.mealService2.updateMemberMealPlan(payload).subscribe(response => {
      if (response == 1) {
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      } else {
        this.setMealPlanHideStatus(meal, false).subscribe();
        this.toast.successMessage('Meal Plan unassigned & moved to drafts successfully');
        this.getOngoingMeals();
      }
    });
  }
  editMealPlan(meal: any) {
    if (!this.isMealPlanUsable(meal)) {
      return;
    }
    this.router.navigate(['/view-edit-plan'], {
      queryParams: {
        memberId: this.memberId,
        id: meal.mealPlanId,
        memberMealId: meal.id,
        fromDate: meal.fromDate.split('T')[0],
        toDate: meal.toDate.split('T')[0],
        mode: 1
      }
    });
  }
  backBtn() {
    this.router.navigate(['/meal-plans']);
  }

  downloadPlan(meal: any){
    if (!this.isMealPlanUsable(meal)) {
      return;
    }
    const id = meal.mealPlanId;
    const name = meal.mealPlanName;
    this.mealService2.downloadMealPlan(id).subscribe((response: any) => {
      if (response == 1) {
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      } else {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name+'.pdf';
        a.click();
        a.remove();
        this.toast.successMessage('Meal Plan Downloaded Successfully');
      }
    }
    );
  }

  viewPlanInputs(meal: any) {
    this.planInputsMealName = meal._mealPlanNameEdit || meal.mealPlanName || '';
    this.planInputsQuestions = [];
    this.planInputsError = '';
    this.planInputsLoading = true;
    this.planInputsModalOpen = true;
    this.mealService2.getPlanQuestionAnswers(meal.id).subscribe({
      next: (response: any) => {
        this.planInputsLoading = false;
        if (response === 1) {
          this.planInputsError = 'Some Exception Occurred. Please try again!';
          return;
        }
        const raw: any[] = Array.isArray(response)
          ? response
          : (response?.questionAnswers ?? response?.items ?? response?.result ?? response?.questions ?? []);
        this.planInputsQuestions = raw.map((q: any) => {
          const selectedLabels = this.parsePlanAnswerLabels(q);
          const triggers = this.freeTextTriggerLabels[String(q?.questionId ?? '')];
          const showFreeText = !!triggers?.length &&
            triggers.some((t: string) => selectedLabels.some(l => l.toLowerCase() === t.toLowerCase()));
          return {
            ...q,
            _selectedLabels: selectedLabels,
            // Some answers (HbA1c value, a picked time, free-text) don't match any known pill —
            // surface the raw answer text in that case so it isn't silently dropped.
            _showRawAnswer: !!String(q?.answer ?? '').trim() && selectedLabels.length === 0,
            _showFreeText: showFreeText,
            _freeText: showFreeText ? this.extractPlanFreeText(q) : ''
          };
        });
      },
      error: () => {
        this.planInputsLoading = false;
        this.planInputsError = 'Some Exception Occurred. Please try again!';
      }
    });
  }

  closePlanInputsModal(): void {
    this.planInputsModalOpen = false;
  }

  // Strips the trailing machine-readable code, e.g. "Mostly sitting - desk, car, sofa (sitting)" -> "Mostly sitting - desk, car, sofa"
  getOptionLabel(option: string): string {
    return (option || '').replace(/\s*\([^)]+\)\s*$/, '').trim();
  }

  // The API returns one free-text `answer` string rather than a list of selected options, so for
  // multi-select questions we greedily match known option labels (longest first) out of that string —
  // same approach used for the member onboarding Q&A tab.
  private parsePlanAnswerLabels(question: any): string[] {
    const answerString = String(question?.answer ?? '').trim();
    if (!answerString) {
      return [];
    }
    const knownOptions: string[] = (question?.questionOptions ?? [])
      .map((o: string) => this.getOptionLabel(o))
      .filter(Boolean);

    if (!knownOptions.length) {
      return answerString.split(',').map((a: string) => a.trim()).filter(Boolean);
    }

    const sorted = [...knownOptions].sort((a, b) => b.length - a.length);
    const result: string[] = [];
    let remaining = answerString;

    while (remaining.length > 0) {
      let matched = false;
      for (const opt of sorted) {
        if (remaining.toLowerCase().startsWith(opt.toLowerCase())) {
          result.push(opt);
          remaining = remaining.slice(opt.length).replace(/^[,\s]+/, '');
          matched = true;
          break;
        }
      }
      if (!matched) {
        const nextComma = remaining.indexOf(',');
        if (nextComma === -1) break;
        remaining = remaining.slice(nextComma + 1).trimStart();
      }
    }
    return result;
  }

  // For trigger questions (e.g. "Add Note"), pulls whatever text follows the matched option's
  // code out of the raw answer string — same approach as the member onboarding Q&A tab.
  private extractPlanFreeText(question: any): string {
    const answerString = String(question?.answer ?? '').trim();
    if (!answerString) {
      return '';
    }
    const knownOptions: string[] = (question?.questionOptions ?? [])
      .map((o: string) => this.getOptionLabel(o))
      .filter(Boolean);
    if (!knownOptions.length) {
      return '';
    }
    const sorted = [...knownOptions].sort((a, b) => b.length - a.length);
    let remaining = answerString;
    while (remaining.length > 0) {
      let matched = false;
      for (const opt of sorted) {
        if (remaining.toLowerCase().startsWith(opt.toLowerCase())) {
          remaining = remaining.slice(opt.length).replace(/^[,\s]+/, '');
          matched = true;
          break;
        }
      }
      if (!matched) {
        const codeMatch = remaining.match(/^\([^)]+\)/);
        if (codeMatch) {
          remaining = remaining.slice(codeMatch[0].length).replace(/^[,\s]+/, '');
          continue;
        }
        // Some answers prefix the free-text portion with a literal "custom:", e.g. "custom:xyz" — show just "xyz".
        return remaining.replace(/^custom\s*:\s*/i, '').trim();
      }
    }
    return '';
  }

  isPlanInputOptionSelected(question: any, option: string): boolean {
    const label = this.getOptionLabel(option).toLowerCase();
    return (question._selectedLabels || []).some((a: string) => a.toLowerCase() === label);
  }

  trackByPlanQuestion(_: number, q: any): any {
    return q.questionId;
  }

  trackByPlanOption(_: number, opt: string): string {
    return opt;
  }

  viewMealPlan(meal: any) {
    if (!this.isMealPlanUsable(meal)) {
      return;
    }
    this.router.navigate(['/view-edit-plan'], {
      queryParams: {
        memberId: this.memberId,
        id: meal.mealPlanId,
        fromDate: meal.fromDate.split('T')[0],
        toDate: meal.toDate.split('T')[0],
        mode: 0
      }
    });
  }

  moveToDraft(meal: any) {
    if (!this.isMealPlanUsable(meal)) {
      return;
    }
    let payload = {
      newObjectId: meal.id,
      reqType: 'toDraft'
    };
    this.mealService2.updateMemberMealPlan(payload).subscribe(response => {
      if (response == 1) {
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      } else {
        this.setMealPlanHideStatus(meal, false).subscribe();
        this.toast.successMessage('Meal Plan Moved to Draft Successfully');
        this.getDraftMeals();
      }
    });
  }

  unassignMealPlan(meal: any) {
    if (!this.isMealPlanUsable(meal)) {
      return;
    }
    this.openUnassignConfirm(meal);
  }
  assignMealPlan(meal: any) {
    let fromDate = meal.fromDate.split('T')[0];
    let toDate = meal.toDate.split('T')[0];
    this.mealService.checkIsPlanAssign(this.memberId, fromDate, toDate).subscribe((response: any) => {
      let isExistPlan: any;
      isExistPlan = response;
      if (isExistPlan.isExist == true) {
        this.newMealPlan = meal;
        this.existingMealPlan = isExistPlan.mealPlan;
        this.exisitngMealPlanName = isExistPlan.mealPlanName;
        let fromDate = this.existingMealPlan.fromDate.split('T')[0];
        this.minDate = new Date(fromDate.split('-')[0], fromDate.split('-')[1] - 1, fromDate.split('-')[2]);
        let toDate = this.existingMealPlan.toDate.split('T')[0];
        this.maxDate = new Date(toDate.split('-')[0], toDate.split('-')[1] - 1, toDate.split('-')[2]);
        this.memMealDate = '';
        this.currentDate = '';
        $('#confirmAssign').modal('show');
      } else {
        let payload = {
          newObjectId: meal.id,
          reqType: 'fromDraft'
        };
        this.mealService2.updateMemberMealPlan(payload).subscribe((response: any) => {
          this.setMealPlanHideStatus(meal, true).subscribe();
          this.toast.successMessage('Meal Plan Assigned Successfully');
          this.getDraftMeals();
        });
      }
    });
  }
  showcheckAssign() {
    $('#confirmAssign').modal('hide');
    $('#checkAssign').modal('show');
  }
  closeConfirmAssign() {
    $('#confirmAssign').modal('hide');
  }
  setMemMealDate(date: HTMLInputElement) {
    var d = formatDate(date.value, 'yyyy-MM-dd', 'en-US');
    this.memMealDate = '';
    if (new Date(this.currentDate) < this.minDate) {
      this.toast.errorMessage('End date must be greater than from date.');
      return;
    }
    if (new Date(this.currentDate) > this.maxDate) {
      this.toast.errorMessage('End date must be less than to date.');
      return
    }
    let fromDate = this.newMealPlan.fromDate.split('T')[0];
    let newMealFromDate = new Date(fromDate.split('-')[0], fromDate.split('-')[1] - 1, fromDate.split('-')[2]);
    if (new Date(this.currentDate) >= newMealFromDate) {
      this.toast.errorMessage('End date must be less than new meal plan start date.');
      return;
    }
    this.memMealDate = d;
  }
  updateAndAssign() {
    if (this.memMealDate == '') {
      this.toast.errorMessage('Please select the end date.');
      return;
    }
    let payload = {
      currentObjectId: this.existingMealPlan.id,
      newObjectId: this.newMealPlan.id,
      date: this.memMealDate,
      reqType: 'fromDraft'
    };
    this.mealService2.updateMemberMealPlan(payload).subscribe(response => {
      if (response == 1) {
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      } else {
        this.setMealPlanHideStatus(this.newMealPlan, true).subscribe();
        this.toast.successMessage('Meal Plan Assigned Successfully');
        $('#checkAssign').modal('hide');
        this.getDraftMeals();
      }
    });
  }
 
  /**
   * Save a draft meal plan as a template.
   * Uses the underlying mealPlanId (plan definition), not the member-specific id.
   */
  saveMealPlanAsTemplate(meal: any) {
    if (!this.isMealPlanUsable(meal)) {
      return;
    }
    // Use mealDayCount from API: only allow if plan has meals for all 7 days (same as extend)
    const mealDayCount = meal.mealDayCount != null ? Number(meal.mealDayCount) : 0;
    if (mealDayCount !== 7) {
      this.cannotCreateTemplateMealName = meal?._mealPlanNameEdit ?? meal?.mealPlanName ?? 'this meal plan';
      this.cannotCreateTemplateMealDayCount = mealDayCount;
      $('#cannotCreateTemplateWarning').modal('show');
      return;
    }

    const planId = meal?.mealPlanId;
    if (!planId) {
      this.toast.errorMessage('Invalid meal plan. Please try again.');
      return;
    }
    if (!this.userId) {
      this.toast.errorMessage('Unable to identify logged-in user. Please try again.');
      return;
    }
    this.isCreatingTemplate = true;
    this.mealService2.saveMealPlanAsTemplate(planId, this.userId).subscribe({
      next: (response: any) => {
        this.isCreatingTemplate = false;
        if (response === 1) {
          this.toast.errorMessage('Some Exception Occurred. Please try again!');
        } else {
          this.createTemplateSuccessMealPlanName = meal?.mealPlanName ?? meal?._mealPlanNameEdit ?? 'Meal Plan';
          this.showCreateTemplateSuccessModal = true;
        }
      },
      error: () => {
        this.isCreatingTemplate = false;
        this.toast.errorMessage('Some Exception Occurred. Please try again!');
      }
    });
  }

  closeCreateTemplateSuccessModal(): void {
    this.showCreateTemplateSuccessModal = false;
    this.createTemplateSuccessMealPlanName = '';
  }

  onCannotCreateTemplateWarningOk(): void {
    $('#cannotCreateTemplateWarning').modal('hide');
  }

}
